import LockIcon from '@mui/icons-material/Lock';
import { Box, ListItem, ListItemText } from '@mui/material';
import { useTheme } from '@mui/material/styles';

interface LockedFieldProps {
  field: string;
  isConditionalField: (rawName: string) => boolean;
  formatMergeField: (field: string) => string;
}

const LockedField: React.FC<LockedFieldProps> = ({
  field,
  isConditionalField,
  formatMergeField,
}) => {
  const theme = useTheme();

  const rawName = field.replace(/[{}]/g, '').trim();
  const displayName = formatMergeField(field);
  const finalConditional = isConditionalField(rawName);

  return (
    <ListItem
      dense
      sx={{
        borderBottom: `1px solid ${theme.palette.divider}`,
        backgroundColor: theme.palette.action.hover, // Slight background to indicate locked/static
        opacity: 0.7,
        py: 0.5, // Reduce padding for tighter list
      }}
    >
      <Box
        sx={{ width: 28, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1 }}
      >
        <LockIcon
          fontSize="small"
          sx={{ color: theme.palette.text.secondary, fontSize: '0.7rem' }}
        />
      </Box>
      <ListItemText
        primary={displayName}
        secondary={
          finalConditional ? 'Defined in current Template.' : 'Defined in current Template'
        }
        slotProps={{
          primary: {
            variant: 'body2',
            sx: {
              fontFamily: 'Montserrat, sans-serif',
              fontWeight: 600,
              fontSize: '1rem',
            },
          },
          secondary: {
            variant: 'caption',
            sx: { fontSize: '0.875rem' },
          },
        }}
      />
    </ListItem>
  );
};

export default LockedField;
